import { useContext } from 'react'

import { OfficeContext } from '@/contexts/OfficeContext'

export const useOfficeContext = () => useContext(OfficeContext)
